export const positiveDecisiveStatKeys = [
  'goals',
  'goal_assist',
  'assist_penalty_won',
  'clearance_off_line',
  'last_man_tackle',
  'penalty_save',
  'clean_sheet_60',
] as const;
export const negativeDecisiveStatKeys = [
  'red_card',
  'own_goals',
  'penalty_conceded',
  'error_lead_to_goal',
  'three_goals_conceded',
] as const;
export const decisiveStatKeys = [
  ...positiveDecisiveStatKeys,
  ...negativeDecisiveStatKeys,
];
export const cardStatKeys = ['yellow_card', 'red_card'] as const;

export const scoutingStatKeys = [
  'mins_played',
  'set_piece_taken',
  'game_started',
  'clean_sheet',
] as const;
